import { getTelegramUserId } from '../utils'

export const useUserId = () => {
  return getTelegramUserId()
}
